import React from 'react';
import ViewPassengerPersonalDetails from './ViewPassengerPersonalDetails/ViewPassengerPersonalDetails';
import ViewPassengerPassportDetails from './ViewPassengerPassportDetails/ViewPassengerPassportDetails';


export default function ViewPassengerDetails({passenger}){

    // const [editingPersonal, setEditingPersonal] = useState(false);
    
    // const handleSetEdit = () => {
    //     setEditingPersonal(!editingPersonal);
    // }
    return(
        <div>
            {/* <div className='view-passenger-title'>
                <strong>{editingPersonal ? 'Editing Personal Details: ' : 'Personal Details'}</strong>
                <STC.Button size='sm' onClick={handleSetEdit}>{editingPersonal ?  'Cancel' : 'Edit'}</STC.Button>
            </div> */}
            {/* {editingPersonal ? 
                <PassengerForm passenger={passenger} editing={editingPersonal} />
                : */}
                <>
                    <ViewPassengerPersonalDetails passenger={passenger} />
                    <ViewPassengerPassportDetails passenger={passenger} />
                </>
            {/* } */}
        </div>
    )
}